<template>
	
	  <a-list 
		:grid="{ gutter: pianYiLiang, xs: 1, sm: 1, md: xlVal, lg: xlVal, xl:xlVal, xxl:xlVal }" 
		:data-source="listDataVal"   
		:locale="locale"
		> 
		  <a-list-item slot="renderItem" slot-scope="item, index" :key="index" class="artlist-item" :class="detail">
			
			<ul class="artlist-item-dir" :title="item.title" :index="index"  v-if="item.folder_id>0 && item.article_id==0 "  @click="toSeltMenu(item.id,item.article_class_id)" >
				<li class="title-bk">
					<span>{{item.folder_name}}</span>
				</li>
				<li class="cont-dir">
					<div class="cont-dir-inform">
						<img  src="@/assets/img/main/icon-dir.png" alt="" />
						<span>查看文件夹</span>
					</div>
				</li>
			</ul>
			<ul class="artlist-item-list" 
				:title="item.title" :index="index"  v-if="item.folder_id>0 && item.article_id>0" 
				data-click="toSeltMenu(item.id,item.article_class_id)" 
				@click="toDetail(item.article_id,item.article_class_id,'list',item.folder_name)"
				>
				<li class="title-bk">
					<span>{{item.folder_name}}</span>
				</li>
				<li class="cont-list">
					<dl  class="cont-dl">
						<dd>
							<img  :src="'/assets/img/main/icon-'+item.file_url_type+'.png'" alt="" />	
						</dd>
						<dd>
							<h3>{{item.title}}</h3>
							<h4>{{item.ftitle}}</h4>
						</dd>
						<dd>
							<span class="color-green" v-if="item.read==true">已读</span>
							<span class="color-red" v-if="item.read==false">未读</span>
						</dd>
						<dd>
							查看 <a-icon type="right" />
						</dd>
					</dl>
				</li>
			</ul>
			<ul class="artlist-item-pdf" :title="item.title" :index="index" 
				v-if="item.folder_id==0 && item.article_id>0  "
				@click="toDetail(item.id,item.article_class_id)" >
				<li>
					<img  :src="'/assets/img/main/icon-'+item.file_url_type+'.png'" alt="" />	
				</li>
				<li>
					<h3>{{item.title}}</h3>
					<h4>{{item.ftitle}}</h4>
				</li>
				<li>
					<span class="color-green" v-if="item.read==true">已读</span>
					<span class="color-red" v-if="item.read==false">未读</span>
				</li>
				<li>
					查看 <a-icon type="right" />
				</li>
			</ul>
		  </a-list-item> 
	</a-list>  
</template>

<script> 
import { P } from 'vue-long-click';
import {getArtItem,findById,findParentPath,modifyNestedArrayById,modifyNestedArrayByKeyName} from '@/utils/util';
export default {
  data() {
    return { 
		listData:[],
    };
  }, 
  components: {
    // TyphoonInfoTreeSelect,
  },
  computed: {   },
  watch:{ 
  },
  props: {
	  //接受父组件传值
      //message: String // 定义一个名为message的prop，类型为String
	  listDataVal:Array,
	  stype:String,
	  pianYiLiang:Number,
	  xlVal:Number, 
	  pagination:Object,
	  locale:Object,
	  seltMenu:Object, 
	  detail:String, 
  },
  created() {   },
  mounted(){
	  //页面初始化 
  },
  methods: { 	  
	  //响应事件 
	  toDetail(data,cat,t="page",name=""){
		 var id=data 
		 
		 var resData=this.listDataVal;
		 if(t=="list")
		 {			 			  
			 var params={
			 	id:cat,
			 	page:1,
			 	pageSize:100, 
				istype:"curpage",
			 };
			 var seltMenuItemVal={id:cat,name:name};
			 this.$store.commit("article/set_seltMenuItem",seltMenuItemVal);
			 this.$store.dispatch("article/GetArticleList",params).then(res=>{
				resData=res.datas.data;
				var seltArtItem=getArtItem(resData,id);
				//console.log("dblclick---2:",seltArtItem);
				this.$store.commit("article/set_seltArtItem",seltArtItem);
				this.$router.push({path:'/'+this.detail,query:{id:id}});//
			 });
		 }
		 else
		 { 
			 var seltArtItem=getArtItem(resData,id);
			 console.log("dblclick---1:",seltArtItem);
			 //console.log("dblclick---",seltArtItem);
			 this.$store.commit("article/set_seltArtItem",seltArtItem);
			 this.$router.push({path:'/'+this.detail,query:{id:id}});//
		 }
	  },
	  toSeltMenu(data1,cat){
		 var id=cat;		 
		 //var menulist=this.$store.state.article.menuList;
		 //var catRow=findById(menulist,id);
		 //this.$store.commit("article/set_seltMenuItem",{id:catRow.id,name:catRow.name});
		 //var seltCatRow=this.$store.state.article.seltMenuItem;		 
		 //console.log("toSeltMenu-id:",id);
		 var data=this.$store.state.article.menuList;
		 if(id>0)
		 { 		   
			   var arr=findById(data,id);
			   this.$store.commit("article/set_seltMenuItem",{id:arr.id,name:arr.name});
			   var pplist=findParentPath(data,id);		
			   this.$store.commit("article/set_pplist",pplist); 
			   this.setActive3(pplist);
			   
			   var menuListData=this.$store.state.article.menuList;
			   for(var i=0;i<pplist.length;i++)
			   {				   
				   menuListData=modifyNestedArrayById(menuListData,pplist[i].id,function(node){
				   		node.class="active";
						node.icon="caret-down";
				   });	
				   if(i===(pplist.length-1))
				   {
					   menuListData=modifyNestedArrayById(menuListData,pplist[i].id,function(node){
					   		node.class3="active3"
					   });	
				   }
			   }
			   this.$store.commit("article/set_menuList",menuListData);
			   //console.log("pplist:",pplist);
			   //this.setActive3(pplist);
			   
			   // if(arr.class=="active")
			   // {
				  //  arr['class']="";
				  //  arr['icon']="caret-right";
			   // }
			   // else{
				  //  arr['class']="active";
				  //  arr['icon']="caret-down";
			   // }
		 				    
		 										
		 }
		 
		 
		 
	  }, 
	  setActive3(pplist)
	  {
		  var menuListData=this.$store.state.article.menuList;
		  menuListData=modifyNestedArrayByKeyName(menuListData,"class3","active3",function(node){
				node.class3=""
		  });
		  if(pplist.length>0)
		  {
			  var ival=pplist[pplist.length-1];			  
			  menuListData=modifyNestedArrayById(menuListData,ival.id,function(node){
				node.class3="active3"
			  });			  
		  }
		  this.$store.commit("article/set_menuList",menuListData);
		  //console.log("setActive3----------------menuListData:",menuListData);
	  }
	  
  },
};
</script>

<style lang="scss" scoped> 
	
	.artlist-item{
		position: relative;
		word-wrap: break-word;
		white-space: unset; 
		margin-bottom:45px;max-height:158px;height:158px;
		.artlist-item-pdf,.artlist-item-dir,.artlist-item-list{ 
			height: 158px; border-radius: 12px; padding:12px; overflow: hidden;
			transition:all 0.2s;
		}
		.artlist-item-pdf:hover,.artlist-item-dir:hover,.artlist-item-list:hover{ 
			border-radius: 0px;
			border: 2px solid rgba(31, 110, 238, 1);
			box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2); 
			transition:all 0.2s;
		}
		.artlist-item-pdf{ 
			position: relative; background-color: #fff; height: 149px; margin-top: 9px;
			li{ float: left;}
			li:nth-child(1){
				width: 13%; text-align: left;
				img{ max-width: 24px; height:auto;margin: 0px auto;display:inline-block}
			}
			
			li:nth-child(2){
				width: 70%; text-align: left; max-width:181px;
				h3{ 
					font-size: 16px; line-height: 24px; font-family: "Source Han Sans CN"; 
					font-weight: 600; margin-bottom: 8px;max-height: 72px; overflow: hidden;
					word-wrap: break-word;
					white-space:break-spaces;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
				h4{ 
					font-size: 16px; 
					font-family: "Source Han Sans CN";
					text-overflow:ellipsis;
					white-space:nowrap;
					overflow: hidden; 
				}
			}
			li:nth-child(3){
				width: 15%;height: 19px;line-height:0px; position: relative;
				text-align: right;
				font-size: 14px; 
				float:right;
				span{ margin: 0px auto; display: block;align-items: center; width: 100%; height: 100%;position: relative;line-height: 19px;}
				.color-green{color:rgba(0, 168, 112, 1)}
				.color-red{color:red}
				.color-red:before{
					content: ''; width:6px; height:6px; border-radius:6px; background-color: red;
					display: block;
					margin-right: 2px; 
				 }
			}
			li:nth-child(4){
				position: absolute;width: 80px;bottom: 15px;right: 10px; text-align: right;font-size: 16px; 
				font-family: "Source Han Sans CN";color:rgba(25, 26, 26, 1)
			}
		} 
		.artlist-item-dir,.artlist-item-list{
			position: relative; background-color: unset; 
			.title-bk{
				position: absolute;
				top: 0px;left: 0;
				width:98%;height: 35px;z-index: 100;
				background-image: url("/assets/img/item-title-dir2.png"); background-position: top left; background-size: 100% 100%;
				span{
					display: block;
					width: 75%;height:22px;line-height: 22px; 
					text-align:left;
					left: 8px; bottom:1px; 
					position: absolute;
					overflow: hidden; text-overflow: ellipsis; white-space:nowrap;
					color: rgba(31, 110, 238, 1); font-weight:600; font-size: 14px;
				}
			}
			.cont-dir{ 
				width: 100%; height: 130px; position: absolute;left: 0px;bottom: 0px; overflow: hidden;
				background: linear-gradient(to bottom,#e6efff,#fdfdfe,#ffffff);
				.cont-dir-inform{ 
					 text-align: center; margin-top:12%;
					img{max-width: 32px;height: auto; margin: 0px auto;}
					span{font-size: 16px; line-height: 24px;color:rgba(25, 26, 26, 1);font-weight: 400;margin-top:8px; }
				}
			}
			
		}
		.artlist-item-list{ 
			.cont-list{ 
				width: 100%; height: 130px; position: absolute;left: 0px;bottom: 0px; overflow: hidden;
				background: linear-gradient(to bottom,#e6efff,#fdfdfe,#ffffff);
				.cont-dl{
					width: 94%;height: 110px;
					margin: 0px auto;   
					margin-top: 12px;
					background-color: #fff;bottom:0px; 
					padding: 10px; padding-top: 12px; padding-bottom: 12px; 
					border: 1px solid #eee;
					border-radius: 12px;
					position: relative;
					display:flex;
					dd{ float: left;}
					dd:nth-child(1){
						width: 22px;max-width: 18%; text-align: left; margin-right: 8px; margin-left: 0px;
						img{ max-width: 22px; height:auto;float: left;}
					}
					dd:nth-child(2){
						width: 66%; text-align: left; 
						h3{ 
							font-size: 16px; line-height: 24px; font-family: "Source Han Sans CN"; 
							font-weight: 600; margin-bottom: 8px;
							word-wrap: break-word;
							white-space:break-spaces;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}
						h4{ 
							font-size: 14px; font-family: "Source Han Sans CN";						 
							 text-overflow:ellipsis;
							 white-space:nowrap;
							 overflow: hidden; 
						 }
					}
					
					dd:nth-child(3){
						width: 18%;text-align: right;font-size: 14px; float:right;
						span{display: block; align-items: center;}
						.color-green{color:rgba(0, 168, 112, 1)}
						.color-red{color:red}
						.color-red:before{
							content: ''; width:6px; height: 6px; border-radius: 6px; background-color: red;display: inline-block;
							margin-right: 2px; line-height:25px;
						 }
					}
					dd:nth-child(4){
						position: absolute;width: 80px;bottom: 15px;right: 10px; text-align: right;font-size: 14px; 
						font-family: "Source Han Sans CN";color:rgba(25, 26, 26, 1)
					}
					
					
				}
			}
		}
		.artlist-item-list:hover{
			dd:nth-child(3){
				width:16%!important;
				span{font-size: 12px;}
			}
		}
	}
	
	.demoDiv{ position: relative;flex: 0 0 auto; height: 100%;left: 0px; top: 0px; display:block; float: left; margin-right: 55px;}

</style>